export const litentryBlockHeightSettings = {
  0: {
    decimals: 12,
  },
  5492090: {
    decimals: 18,
  },
};
